import styled from "styled-components"

const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f7f7f7;
  padding: 6rem;
  h1 {
    font-size: 46px;
    color: #172315;
    font-weight: 700;
    text-align: center;
    margin-bottom: 2rem;
  }

  .ant-spin-spinning {
    margin: 8rem;
    overflow: hidden;
    padding: 2rem;
  }

  .styled-button {
    width: 159px;
    height: 48px;
    background-color: #172315;
    border: none;
    font-size: 18px;
    color: #ffffff;
    font-weight: 600;
    cursor: pointer;
  }

  .ant-row {
    width: 100%;
  }

  select {
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
    padding: 10px 10px 10px 10px;
    width: 100%;
    background-color: #f7f7f7;
    border: 1.5px solid #d3ddd1;
  }

  .input-css {
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
    padding: 10px 10px 10px 10px;
    width: 100%;
    background-color: #f7f7f7;
    border: 1.5px solid #d3ddd1;
  }

  ${({ theme: { down, breakpoints } }) => down(breakpoints.md)} {
    padding: 6rem;
    h1 {
      font-size: 26px;
      color: #172315;
      font-weight: 700;
      text-align: center;
      margin-bottom: 2rem;
    }
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.lg)} {
    padding: 2rem;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.sm)} {
    padding: 1rem;
  }
`

export default StyledSection
